import React, { useEffect,useMemo, useState } from "react";
import withRouter from "../../../components/Common/withRouter";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  FormFeedback,
  Label,
  Input,
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import { Link, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
const ManageFeatures = () => {
  const baseurl = process.env.REACT_APP_BASE_URL;
  const params = useParams();

  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [addFeatures, setAddFeatures] = useState(null);
  const [FeaturesData, setFeaturesData] = useState([]);
  const [error, setError] = useState(null);
  const toggleModal = () => setModal(!modal);

  const fetchFeaturesData = async () => {
    try {
      setError(null); // Reset error before fetching
      const response = await fetch(`${baseurl}/admin/master/subsubcategories/${params?.id}/feature`);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setFeaturesData(data);
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    fetchFeaturesData();
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (addFeatures && addFeatures.id) || "",
      feature: (addFeatures && addFeatures.featurename) || "",
      status: (addFeatures && addFeatures.status) || "Active",
    },
    validationSchema: Yup.object({
      feature: Yup.string().required("Please enter the features name"),
      status: Yup.string().required("Please select the status"),
    }),
    onSubmit: async (values) => {
      const { id, feature, status } = values;
  
      try {
        let response;
        if (isEdit) {
          // For edit, make an API PUT request
          response = await fetch(`${baseurl}/admin/master/subsubcategories/${params?.id}/feature/${id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              featurename: feature,
              sscid: params?.id,
              status : status,
            }),
          });
          if (!response.ok) {
            throw new Error("Error updating user");
          }
           toast.success('Feature updated successfully!', 'success');
          fetchFeaturesData();
        } else {
          // For add, make an API POST request
          response = await fetch(`${baseurl}/admin/master/subsubcategories/${params?.id}/feature`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              featurename: feature,
              sscid: params?.id,
              status : status,
            }),
          });
          if (!response.ok) {
            throw new Error("Error adding new user");
          }
           toast.success('Feature added successfully!', 'success');
          fetchFeaturesData();
        }
        // Close modal or do further actions
        toggleModal();
      } catch (error) {
        console.error(error);
        // Handle any errors, show an error message if needed
      }
    },
  });

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
      },
      {
        Header: "Feature Name",
        accessor: "featurename",
        filterable: true,
      },

      {
        Header: "Status",
        accessor: "status",
        filterable: true,
        Cell: ({ value }) => (
          <Badge color={value === "Active" ? "success" : "danger"}>
            {value.charAt(0).toUpperCase() + value.slice(1)}
          </Badge>
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: ({ row }) => (
          <div className="d-flex gap-3">
            <Link
              to="#"
              className="text-success"
              onClick={() => handleEditClick(row.original)}
            >
              <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
              <UncontrolledTooltip placement="top" target="edittooltip">
                Edit
              </UncontrolledTooltip>
            </Link>
          </div>
        ),
      },
    ],
    []
  );

  const handleEditClick = (features) => {
    setAddFeatures(features);
    setIsEdit(true);
    toggleModal();
  };

  const handleAddFeatures = () => {
    setAddFeatures(null);
    setIsEdit(false);
    toggleModal();
  };

  return (
    <>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs
            title="Sub Sub-Categories"
            breadcrumbItem={`Add Features - ${params?.id}`}
          />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={FeaturesData}
                    isGlobalFilter={true}
                    customPageSize={10}
                    isAddFeatures={true}
                    handleAddFeatures={handleAddFeatures}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Modal for Add/Edit Sub Sub-Categories Features*/}
          <Modal
            isOpen={modal}
            toggle={toggleModal}
            backdrop="static"
            keyboard={false}
          >
            <ModalHeader toggle={toggleModal} tag="h4">
              {isEdit ? "Edit Features" : "Add Features"}
            </ModalHeader>
            <ModalBody>
              <form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col className="col-12">
                    <div className="mb-3">
                      <Label className="form-label">Features Name</Label>
                      <Input
                        name="feature"
                        type="text"
                        placeholder="Insert Features Name"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.feature || ""}
                        invalid={
                          formik.touched.feature && formik.errors.feature
                            ? true
                            : false
                        }
                      />
                      {formik.touched.feature && formik.errors.feature ? (
                        <FormFeedback type="invalid">
                          {formik.errors.feature}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Status</Label>
                      <Input
                        name="status"
                        type="select"
                        className="form-select"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.status || ""}
                      >
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </Input>
                      {formik.touched.status && formik.errors.status ? (
                        <FormFeedback type="invalid">
                          {formik.errors.status}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      <Button type="submit" color="success">
                        {isEdit ? "Update" : "Save"}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </form>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </>
  );
};

export default withRouter(ManageFeatures);
